<template>
  <div>
    <!-- <InterForm @querySubmit="queryHandler" /> -->

    <InterBtnBox @overEmit="getDataSource" :printBusinessType="2" />

    <InterList
      :dataSource="dataSource"
      @overEmit="getDataSource"
      :printBusinessType="2"
    ></InterList>
  </div>
</template>

<script>
import { printConfigPage } from "@/apis/configure";
import store from "@/store";
import { getMacAddress } from "@/apis/autoPrint";
import { autoGetMac } from "@/utils/autoPrint";
import InterForm from "./components/InterForm";
import InterList from "./components/InterList";
import InterBtnBox from "./components/InterBtnBox";
export default {
  title: "批次水洗标",
  name: "washLabel",
  components: {
    InterForm,
    InterBtnBox,
    InterList,
  },
  data() {
    return {
      dataSource: [],
    };
  },
  computed: {},
  mounted() {
    this.queryHandler();
  },
  methods: {
    queryHandler(payload) {
      this.getDataSource(payload);
    },
    async getDataSource(payload) {
      let mac = await autoGetMac();
      if (!mac || !mac.data) {
        this.$message.warning("mac地址获取失败，请启动打印软件后刷新重试");
        return;
      }
      let params = {
        printBusinessType: 2,
        ...payload,
        macAddress: mac.data,
      };
      printConfigPage(params).then((res) => {
        if (res.success) {
          this.dataSource = res.data.records;
        }
      });
    },
  },
};
</script>

<style scoped></style>
